import { UserNotification, UserNotificationState } from "@api";
import { ActivityViewerComponent } from "./feed/public/activity/activity-viewer.component";
import { MatDialog } from "@angular/material/dialog";
import moment from "moment";

export class Notification {
    id: string;
    icon: string;
    title: string;
    subtitle: string;
    userNotification: UserNotification;

    constructor(id, icon, title, subtitle, userNotification) {
        this.id = id;
        this.icon = icon;
        this.title = title;
        this.subtitle = subtitle;
        this.userNotification = userNotification;
    }

    get isRead() {
        return this.userNotification.state === UserNotificationState._1;
    }
}

export type ActivityNotificationDataType = "Valor.Health.Engage.Application.Notification.Data.ActivityNotificationData";

export class EngageNotificationParser {
    static Type: ActivityNotificationDataType =
        "Valor.Health.Engage.Application.Notification.Data.ActivityNotificationData";

    constructor(private _matDialog: MatDialog) {}

    parse(userNotification): Notification {
        let subtitle = moment(userNotification.notification.creationTime)
            .locale("pt-BR")
            .local()
            .format("ddd, DD [de] MMM [de] YYYY [às] HH:mm");

        return new Notification(
            userNotification.id,
            "assignment_turned_in",
            "Resposta de atividade",
            subtitle,
            userNotification
        );
    }

    open(notification: Notification) {
        this._matDialog.open(ActivityViewerComponent, {
            panelClass: "activity-viewer-dialog",
            data: {
                itemId: notification.userNotification.notification.data.properties.itemId,
                timestamp: notification.userNotification.notification.data.properties.timestamp,
            },
        });
    }
}
